import Switcher from 'library/components/switcher';
import { ListItem, Text } from './styles';

const Item = ({
  id,
  name,
  onChange,
  value,
}) => (
  <ListItem>
    <Text>{name}</Text>
    <Switcher
      id={id}
      value={value}
      defaultChecked={value}
      onChange={onChange}
    />
  </ListItem>
);

export default Item;
